import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAccountStore } from '../../../components/Stores/accountStore';
import { useMaterialsStore } from '../../../components/Stores/MaterialsStore';
import ButtonDesigned from '../../../components/UI-Elements/Buttons/ButtonDesigned';
import { useAllProducts } from '../../../hooks/useProducts';
import { Product } from '../../../sp-types/productType';
import { LoadingLogoComponent } from '../../Quotes/LoadingLogoComponent';
import { ProductCardMap } from './Components/ProductCardMap';
import { IProductFilters, ProductFilterSection } from './Components/ProductFilterSection';
import { filterProductList } from '../productUtils';
import { useTopBarComponent } from '../../../components/Stores/TopBarComponentStore';

export const NEW_PRODUCT_URL_PARAM = 'create-new';

export const ProductDashboard = () => {
  const { account } = useAccountStore();
  const { materialsMap } = useMaterialsStore();
  const { setTopBarComponent } = useTopBarComponent();
  const { data, isLoading } = useAllProducts(account.id);
  const [filteredProductList, setFilteredProductList] = useState<Product[]>([]);
  const [filters, setFilters] = useState<IProductFilters>({});
  const [categories, setCategories] = useState<Record<string, string[]>>({});
  const { formulaColorDictionary } = useAccountStore();
  const [selectedProductId, setSelectedProductId] = useState('');
  const navigate = useNavigate();

  /// Mounting and unMounting the Add Product button
  useEffect(() => {
    setTopBarComponent(
      <ButtonDesigned
        style="outline"
        onButtonClick={() => {
          navigate(`/setting-product-create/${NEW_PRODUCT_URL_PARAM}`);
        }}
      >
        Add Product
      </ButtonDesigned>,
    );
  }, []);

  useEffect(() => {
    return () => {
      setTopBarComponent(undefined);
    };
  }, [setTopBarComponent]);

  useEffect(() => {
    const setProductList = () => data && setFilteredProductList(filterProductList(data, filters));

    setProductList();
  }, [data, filters]);

  useEffect(() => {
    const setNewCategories = () => data && setCategories(getAllCategories(data));

    setNewCategories();
  }, [data]);

  if (isLoading) return <LoadingLogoComponent />;

  return data && materialsMap && formulaColorDictionary ? (
    <div className="flex flex-col gap-2  h-full pb-10 px-2">
      <ProductFilterSection
        categories={categories}
        filters={filters}
        materialsMap={materialsMap}
        setFilters={setFilters}
      />
      <ProductCardMap
        filteredProductList={filteredProductList}
        formulaColorDictionary={formulaColorDictionary}
        materialsMap={materialsMap}
        selectedProductId={selectedProductId}
        setSelectedProductId={setSelectedProductId}
      />
    </div>
  ) : (
    <div>noData</div>
  );
};

const getAllCategories = (productList: Product[]): Record<string, string[]> => {
  return productList.reduce((acc, { category, subCategory }) => {
    if (!acc[category]?.includes(subCategory) && category && subCategory) {
      acc[category] = [...(acc[category] || []), subCategory];
    }
    return acc;
  }, {} as Record<string, string[]>);
};
